/* istanbul ignore file */
import { grid, maxWidthContainerWithoutGutters } from '@noths/polaris-client-ribbons-base';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = themeVariables;

export const wrapper = css`
  margin: 0 0 var(${spacing.xl}) 0;
`;

export const container = css`
  ${grid}
  ${maxWidthContainerWithoutGutters};
  grid-row-gap: 0;
  padding: 0;
`;
